import { useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { ResetPasswordForm } from "@/components/Complex/ResetPasswordForm/resetPasswordForm"
import { useConfig } from "@/hooks/useConfig"
import { resetForgottenPassword } from "@/lib/api/auth"
import { AuthLayout } from "@/components/Primitives/AuthLayout"
import { getPasswordValidation } from "@/lib/utils/utils"
import { getPasswordMessages, getPasswordSchema } from "@/lib/schemas/auth"

export function ResetPasswordPage() {
  const { t, tp } = useConfig()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [password, setPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState("")

  const code = searchParams.get("reset_code") || ""
  const passwordSchema = getPasswordSchema(t)
  const passwordValidation = getPasswordValidation(password, t)
  const passwordResult = passwordSchema.safeParse(password)

  const isPasswordValid =
    passwordResult.success && password === confirmPassword && !!password

  const handleSubmit = async () => {
    try {
      setError("")
      setIsSubmitting(true)
      const status = await resetForgottenPassword(code, password)
      if (status === 200) {
        navigate("/login/reset/success")
      } else if (status === 404 || status === 400) {
        setError(tp("config_reset_password_error_code", { code }))
      } else {
        setError(t("config_reset_password_error_generic"))
      }
    } catch {
      setError(t("config_reset_password_error_generic"))
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <AuthLayout
      description={t("config_reset_password_description")}
      imageUrl="/images/open-box.webp"
    >
      <ResetPasswordForm
        password={password}
        confirmPassword={confirmPassword}
        onPasswordChange={setPassword}
        onConfirmPasswordChange={setConfirmPassword}
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
        error={error}
        passwordValidation={passwordValidation}
        passwordRequirements={getPasswordMessages(t).map((label) => ({
          label,
        }))}
        isPasswordValid={isPasswordValid}
      />
    </AuthLayout>
  )
}
